import ListItem from "../components/ListItem";

export default function Dashboard() {
  return (
    <>
      <ListItem admin={false} />
    </>
  );
}
